import { Menu, MenuItem } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Languages from "services/i18n/languages";

import ArrowDown from "assets/Icons/arrowDown.svg?react";
import MDTypography from "components/MDTypography";
import i18n from "services/i18n/i18n";
import { styles } from "./SelectLanguage.styles";

import { useMaterialUIController, setDirection } from "context";
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  getDirectionForLanguage,
  removeLangParamFromSearch,
} from "utils/language.util";

const SelectLanguage = () => {
  const [{ direction }, dispatch] = useMaterialUIController();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const [menu, setMenu] = useState(null);
  const [selectedLang, setSelectedLang] = useState<string>(() => {
    return i18n.language || localStorage.getItem(LANGUAGE_STORAGE_KEY) || DEFAULT_LANGUAGE;
  });
  const useStyles = makeStyles()((theme) => styles(theme));
  const { classes } = useStyles();

  // Listen to i18n language changes to keep the component in sync
  useEffect(() => {
    const updateLanguage = (lng: string) => {
      setSelectedLang(lng);
    };

    // Set initial language
    const currentLang =
      i18n.language || localStorage.getItem(LANGUAGE_STORAGE_KEY) || DEFAULT_LANGUAGE;
    setSelectedLang(currentLang);

    // Listen to language change events
    i18n.on("languageChanged", updateLanguage);

    return () => {
      i18n.off("languageChanged", updateLanguage);
    };
  }, []);

  const openMenu = (event: any) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  const handleSelect = (lang: string) => {
    if (lang !== selectedLang) {
      const langDirection = getDirectionForLanguage(lang);
      // appDispatch(updateSelectedLangauge({ selectedLanguage: lang }));
      setDirection(dispatch, langDirection);
      i18n.changeLanguage(lang);
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
      setSelectedLang(lang);

      const nextSearch = removeLangParamFromSearch(search);
      if (nextSearch !== search) {
        navigate({ pathname, search: nextSearch, hash }, { replace: true });
      }
    }
    closeMenu();
  };

  return (
    <>
      {/* <MDButton
        variant={"outlined"}
        style={{}}
        classes={{ root: classes.button }}
        onClick={openMenu}
      > */}
      <div className={classes.container} onClick={openMenu}>
        <MDTypography
          variant="button"
          color="black"
          marginRight={direction === "rtl" ? "" : "8px"}
          marginLeft={direction === "ltr" ? "" : "8px"}
        >
          {Languages.find((l) => l.key === selectedLang)?.label || selectedLang}
        </MDTypography>
        <ArrowDown />
      </div>
      {/* </MDButton> */}
      <Menu
        anchorEl={menu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: direction === "ltr" ? "left" : "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: direction === "ltr" ? "left" : "right",
        }}
        open={Boolean(menu)}
        onClose={closeMenu}
        keepMounted
        disableAutoFocusItem
      >
        {Languages.map((lang) => (
          <MenuItem
            className={classes.menuItem}
            key={lang.key}
            onClick={() => handleSelect(lang.key)}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SelectLanguage;
